<template>
  <v-row :key="message.id + '_' + message.lastUpdatedTimestamp"
         :class="message.type === 'question' ? 'rowQuestion' : 'rowReply'" justify="center" no-gutters
         row
         wrap>
    <v-col cols="12" lg="8" md="10" xl="6">
    <v-container>
        <v-row no-gutters>
          <v-col cols="12">
            <v-list-item class="px-0">
              <v-list-item-avatar :color="message.type === 'question' ? 'rowReply' : 'rowQuestion'"
                                  size="36"
                                  class="elevation-3"
                                  rounded
                                  style="align-self: start">
                <v-icon v-if="message.type === 'reply'" color="primary">mdi
                  mdi-robot-happy
                </v-icon>
                <v-icon v-if="message.type === 'question'" color="accent2">mdi
                  mdi-account
                </v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <div style="position: relative; width: 100%;">
                  <div v-if="!!message.message" class="body-1 pr-2"
                       :class="{'text-pre-wrap': message.type !== 'reply'}">
                    <div class="pr-2">
                      <marked-wrapper :content="message.message"></marked-wrapper>
                    </div>

                    <template
                        v-if="!!message.message && message.type === 'reply' && !message.inflight && parsedSourceMetadata.sources && parsedSourceMetadata.sources.length && message.id !== 'disclaimer_message'">
                      <div class="pt-2 pr-4">
                        <div class="caption">{{ $t('Sources') }}:</div>
                        <v-chip v-for="source in parsedSourceMetadata.sources" :key="source.path" :href="source.url"
                                target="_blank" :link="!!source.url" class="mr-1" small>
                          <div class="text-truncate">{{ source.path }}</div>
                        </v-chip>
                      </div>
                    </template>
                  </div>
                  <div v-else-if="message.error">
                    <v-alert type="error" prominent text class="mt-n1 mb-0" dense>
                      {{ message.reply || $t('generic_error_message') }}
                    </v-alert>
                  </div>
                  <div v-else-if="loading" class="body-1">
                    <v-skeleton-loader light
                                       loading
                                       type="paragraph"></v-skeleton-loader>
                  </div>

                  <div
                      v-if="message.type === 'reply' && !!message.message && message.id !== 'disclaimer_message' && !message.inflight"
                      class="pt-3 pr-4 text-right">
                    <span class="caption mr-1">{{ $t('did_you_get_your_answer') }}</span>
                    <v-btn color="accent2 darken-4" icon small tile @click="voteUp">
                      <v-icon small v-if="message.rating === 1">mdi mdi-thumb-up</v-icon>
                      <v-icon small v-else>mdi mdi-thumb-up-outline</v-icon>
                    </v-btn>
                    <v-btn color="accent2 darken-4" icon small tile @click="voteDown">
                      <v-icon small v-if="message.rating === -1">mdi mdi-thumb-down</v-icon>
                      <v-icon small v-else>mdi mdi-thumb-down-outline</v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-list-item-content>

            </v-list-item>

            <v-alert prominent :value="message.id === 'disclaimer_message'" type="info" text class="mt-5 caption" dense>
              <p>{{ $t('ai_disclaimer_long_1') }} <a :href="disclaimerLink" target="_blank">[{{ $t('more_info') }}]</a>
              </p>
              <p>{{ $t('ai_disclaimer_long_2') }}</p>
              <p class="mb-1">{{ $t('ai_disclaimer_long_3') }}</p>
            </v-alert>
          </v-col>
        </v-row>
      </v-container>
    </v-col>
  </v-row>
</template>
<script>
import MarkedWrapper from "@/views/EmbedChat/components/MarkedWrapper.vue";

export default {
  name: 'chat-message-item',
  components: {MarkedWrapper},
  props: {
    message: {},
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      replyCopied: false,
    }
  },
  computed: {
    disclaimerLink() {
      switch (this.$i18n.locale) {
        case 'fi':
          return 'https://www.harvia.com/fi/tietosuojaseloste/';
        case 'en':
          return 'https://www.harvia.com/en/privacy-notice/';
        case 'en-us':
          return 'https://www.harvia.com/en-US/privacy-notice/';
        case 'de':
          return 'https://www.harvia.com/de/registerbeschreibung/';
        case 'sv':
          return 'https://www.harvia.com/sv/registerbeskrivning/';
        case 'et':
          return 'https://www.harvia.com/et/registri-valjavote/';
      }
      return 'https://www.harvia.com/en/privacy-notice/';
    },
    parsedSourceMetadata() {
      function getFileNameAndParentFolder(url, message) {

        if (url?.startsWith("http")) {
          return {path: url, url: url};
        } else {
          return {
            path: url,
            url: `https://stgaichatbotprodswe.blob.core.windows.net/docs-${message.indexName}/${encodeURIComponent(url)}`
          };
        }
        /*const pathSegments = s3Path.split('/'); // Split the path into segments
        const fileName = pathSegments.pop(); // Get the last segment as the file name
        const parentFolder = pathSegments.pop(); // Get the segment before the file name as the parent folder

        return [parentFolder, fileName].filter(Boolean).join('/');*/
      }

      if (this.message.sourceUrl) {
        return {sources: [getFileNameAndParentFolder(this.message.sourceUrl, this.message)]};
      }

      if (!this.message.sourceMetadata) return {sources: []};
      let m = null;
      try {
        m = JSON.parse(this.message.sourceMetadata);
      } catch (e) {
        return {sources: []};
      }
      const uniqBy = (arr, key) => arr.filter((v, i, a) => a.findIndex(t => t[key] === v[key]) === i);
      if (m) {
        return {sources: Array.from(new Set(uniqBy(m.map(s => getFileNameAndParentFolder(s.source, this.message)), 'path'))).filter(Boolean)};
      } else {
        return {sources: []};
      }

    },
  },
  watch: {},
  methods: {
    voteUp() {
      this.$emit('vote-up', this.message, 1);
    },
    voteDown() {
      this.$emit('vote-down', this.message, -1);
    },
    copyReply() {
      navigator.clipboard.writeText(this.message.message)
          .then(() => {
            this.replyCopied = true;
            setTimeout(() => {
              this.replyCopied = false;
            }, 1350);
          })
          .catch(err => {
            console.error('Could not copy text: ', err);
          });
    }
  },
}
</script>
